import React, { useState } from 'react';
import kite from '../pngs/Group 274 1.png';
import diwaliImg from '../pngs/Fireworks.mp4'
// import Christmas from '../pngs/Merry Christmas (1).gif'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../components-css/contact-us.scss';
import axios from 'axios';
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import blackfridaygif from '../pngs/Black Friday Green.gif'
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet-async';
import attachmentBtn from '../assets/svgs/attachment-btn.svg';

const ContactUs = () => {
    const [name, setName] = useState('');
    const [consent, setConsent] = useState(false);
    const [smsConsent, setSmsConsent] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState(''); // Add this state
    const [project, setProject] = useState('');
    const [selectedServices, setSelectedServices] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [errors, setErrors] = useState({});

    const handlePhoneChange = (value, country) => {
        setPhone(value);
        setCountryCode(country.dialCode);
    };

    const validateFields = () => {
        const newErrors = {};
        if (!name.trim()) newErrors.name = ['Name is required'];
        if (!email.trim()) {
            newErrors.email = ['Email is required'];
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = ['Email format is invalid'];
        }
        if (!phone.trim()) {
            newErrors.number = ['Phone number is required'];
        } else if (!/^[0-9]{10,15}$/.test(phone)) {
            newErrors.number = ['Phone must be 10 to 15 digits'];
        }
        if (!project.trim()) newErrors.about_project = ['Project description is required'];
        if (selectedServices.length === 0) newErrors.service = ['Please select at least one service'];

        // SMS consent is optional — no validation needed

        // Privacy Policy + T&C is mandatory
        // if (!consent) newErrors.consent = ['Please accept the Privacy Policy and Terms & Conditions'];

        return newErrors;
    };

    const postContact = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        try {
            const token = await window.grecaptcha.execute('6LebgI4rAAAAAPhRn6VH0DW687PInYqxB8BPxsXE', { action: 'submit' });

            const payload = {
                name,
                email,
                number: '+' + phone,
                about_project: project,
                service: selectedServices,
                recaptchaToken: token
            };

            const response = await axios.post('https://newomkatech.omkatech.in/api/contact-us', payload);

            setName('');
            setEmail('');
            setPhone('');
            setProject('');
            setSelectedServices([]);
            setConsent(false);
            setSmsConsent(false);
            setErrors({});

            toast.dismiss();
            toast.success(response?.data?.message || "Message sent successfully!", { toastId: "success-msg" });

        } catch (error) {
            toast.dismiss();
            if (error.response?.data?.errors) {
                setErrors(error.response.data.errors);
            } else {
                toast.error(error?.response?.data?.message || "Failed to send your message. Please try again.", { toastId: "error-msg" });
            }
        }
    };

    const toggleHighlight = (service) => {
        setSelectedServices((prev) =>
            prev.includes(service) ? prev.filter((item) => item !== service) : [...prev, service]
        );
    };

    const services = [
        'Mobile App Development',
        'Web Design & Development',
        'Software Development',
        'SEO',
        'UI/UX Design',
        'Digital Marketing',
        'IT Managed Services',
    ];

    return (
        <div className="contact-us-main-container">
            <Helmet>
                <title>Contact Omka Tech | Get in Touch with Our Team</title>
                <meta name="description" content="Contact Omka Tech for website development, mobile app, digital marketing, and IT services. Get in touch with our expert team." />
                <link rel="canonical" href="https://omkatech.com/contact-us" />
            </Helmet>
            <ToastContainer />
            <div className="contact-heading">
                <h1>
                    Contact <span><b>Omka Tech</b></span> -Let's Start Your Project
                </h1>
                <div className='diwali-video'>
                    <img src={kite} alt="" />
                </div>

            </div>
            <div className="contact-us">
                <div className={`your-name ${errors.name ? '' : 'mb-30'}`}>
                    <input
                        type="text"
                        value={name}
                        placeholder="Your Name *"
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                {errors.name && <div className="error-text">{errors.name[0]}</div>}
                <div className={`your-name ${errors.email ? '' : 'mb-30'}`}>
                    <input
                        type="email"
                        value={email}
                        placeholder="Your Email *"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                {errors.email && <div className="error-text">{errors.email[0]}</div>}
                <div className={`your-name flag ${errors.number ? '' : 'mb-30'}`}>

                    <PhoneInput
                        country={'in'}
                        value={phone}
                        onChange={setPhone}
                        inputProps={{
                            required: true,
                            autoFocus: false,
                            placeholder: 'Select country and enter phone number'
                        }}
                        disableCountryCode={false}
                        countryCodeEditable={false}
                        enableAreaCodes={false}
                        prefix="+"
                    />
                </div>
                {countryCode && (
                    <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
                        Selected Country Code: +{countryCode}
                    </div>
                )}

                {errors.number && <div className="error">{errors.number[0]}</div>}
                <div className={`your-name ${errors.about_project ? '' : 'mb-30'}`}>
                    <input
                        type="text"
                        value={project}
                        onChange={(e) => setProject(e.target.value)}
                        placeholder="Tell us about your project *"
                    />
                </div>
                {errors.about_project && <div className="error-text">{errors.about_project[0]}</div>}
                <div className="choose-service">
                    <p>Choose your Service</p>
                    <div className="services-container">
                        {services.map((service, index) => (
                            <div
                                key={index}
                                className={`service ${selectedServices.includes(service) ? 'active' : ''}`}
                                onClick={() => toggleHighlight(service)}
                            >
                                {service}
                            </div>
                        ))}
                    </div>
                    {errors.service && <div className="error-text">{errors.service[0]}</div>}
                </div>
                <div className="attachment-button" style={{ position: 'relative' }}>
                    <span className="heading">Add Attachments: </span>
                    <div className="attachment-btn" style={{ position: 'relative', overflow: 'hidden' }}>
                        Add Attachment
                        <span><img src={attachmentBtn} alt="attachment-btn" /></span>
                        <input
                            type="file"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                opacity: 0,
                                cursor: 'pointer'
                            }}
                        />
                    </div>
                </div>

                {/* Checkbox 1: SMS Consent — Optional */}
                <div style={{ marginTop: '20px' }}>
                    <label style={{ display: 'flex', gap: '10px', fontWeight: '200', alignItems: 'flex-start', fontSize: '14px', cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={smsConsent}
                            onChange={(e) => setSmsConsent(e.target.checked)}
                            style={{ marginTop: '3px' }}
                        />
                        <span className='consent-text'>
                            By checking, you are allowing to receive transactional/informational SMS communications regarding account notifications, customer care, etc, from Omka Tech. Messages frequency may vary. Message and data rates may apply, reply HELP for help or STOP to opt-out.
                        </span>
                    </label>
                </div>

                {/* Checkbox 2: Privacy Policy + T&C — Mandatory */}
                <div style={{ marginTop: '20px' }}>
                    <label style={{ display: 'flex', gap: '10px', fontWeight: '200', alignItems: 'flex-start', fontSize: '14px', cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            // checked={consent}
                            onChange={(e) => setConsent(e.target.checked)}
                            style={{ marginTop: '3px' }}
                        />
                        <span className='consent-text'>
                            By checking, I accept{" "}

                            <Link
                                to="/terms-&-conditions"
                                style={{ textDecoration: "none", color: "#FEAA00" }}
                            >
                                Terms & Conditions
                            </Link>
                            {" "}&{" "}
                            <Link
                                to="/privacy-policy"
                                style={{ textDecoration: "none", color: "#FEAA00" }}
                            >
                                Privacy Policy.
                            </Link>
                        </span>
                    </label>
                    {errors.consent && <div className="error-text">{errors.consent[0]}</div>}
                </div>

                <div className="button">
                    <button
                        onClick={postContact}
                        className="btn-bg"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <span>Submit</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;